interface Props {
    text: string;
    className?: string;
    width?: string;
}

export const DirectBookingBanner = ({ text, className = '', width }: Props) => (
    <div
        className={`panel panel--tips u-ma0 u-pa4 u-mb8--lt768 u-d1 flex flex-align-end flex-justify-center ${className}`}
        style={{ width }}>
        <i className="icon icon--star-mini-light-blue u-mr4" />
        {text}
    </div>
);
